// components/RequireRole.jsx
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const RequireRole = ({ allowedRoles, children }) => {
  const user = useSelector((state) => state.global.user);

  // Not logged in → back to login
  if (!user) return <Navigate to="/login" replace />;

  // Not allowed → redirect to role-appropriate default (guard: allowedRoles may be undefined)
  if (!Array.isArray(allowedRoles) || !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireRole;
